import React from "react";
import Base3DButton from "./Base3DButton";
import { use3DButtonState } from "@/hooks/use3DButtonState";

interface WordButton3DProps {
  word: string;
  index: number;
  onClick: (word: string, index: number) => void;
  disabled?: boolean;
  isCorrect?: boolean;
  showResult?: boolean;
}

const WordButton3D: React.FC<WordButton3DProps> = ({ 
  word, 
  index, 
  onClick, 
  disabled = false,
  isCorrect = false,
  showResult = false
}) => {
  const { isAnimating, color, handleClick } = use3DButtonState(
    showResult ? isCorrect : undefined,
    showResult,
    () => onClick(word, index)
  );

  const handleButtonClick = () => {
    if (disabled) return;
    handleClick();
  };

  return (
    <div className="relative inline-block m-1">
      <Base3DButton
        onClick={handleButtonClick}
        disabled={disabled}
        small={true}
        color={color}
        isAnimating={isAnimating}
        style={disabled ? {
          opacity: 0,
          backgroundColor: "var(--color-grey-light)",
          color: "var(--color-grey-dark)",
          cursor: "not-allowed"
        } : undefined}
      >
        {word}
      </Base3DButton>
    </div>
  );
};

export default WordButton3D;
